var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDiscord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_273_811)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60ZM34.8269 16.6667C37.3079 17.0984 39.6809 17.8567 41.9003 18.9C45.7809 24.7226 47.709 31.2896 46.997 38.864C44.028 41.0945 41.148 42.4478 38.3164 43.3333C37.6153 42.3675 36.9951 41.3381 36.4584 40.2588C37.4805 39.8685 38.462 39.387 39.3897 38.8253C39.147 38.6426 38.907 38.4516 38.6724 38.2552C33.0983 40.9064 26.9688 40.9064 21.3273 38.2552C21.0954 38.4516 20.8554 38.6426 20.61 38.8253C21.535 39.3843 22.5138 39.8658 23.5359 40.256C22.9992 41.3381 22.3763 42.3648 21.6779 43.3306C18.8491 42.445 15.9717 41.0917 13.0027 38.864C12.3959 32.3302 13.6094 25.7023 18.0859 18.9055C20.3053 17.8595 22.6811 17.0984 25.1647 16.6667C25.4721 17.2202 25.8362 17.9646 26.0816 18.5568C28.6704 18.1583 31.2835 18.1583 33.9208 18.5568C34.1662 17.9646 34.5222 17.2202 34.8269 16.6667ZM21.2218 31.3218C21.2218 33.2562 22.6107 34.8447 24.3042 34.8447C26.0274 34.8447 27.3892 33.2562 27.3865 31.3218C27.4161 29.3846 26.0274 27.7961 24.3042 27.7961C22.581 27.7961 21.2218 29.3874 21.2218 31.3218ZM35.6952 34.8447C34.0017 34.8447 32.6128 33.2562 32.6128 31.3218C32.6128 29.3874 33.9719 27.7961 35.6952 27.7961C37.4183 27.7961 38.8071 29.3846 38.7775 31.3218C38.7775 33.2562 37.4183 34.8447 35.6952 34.8447Z",
    fill: "url(#paint0_linear_273_811)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_273_811",
    x: -400,
    y: -400,
    width: 860,
    height: 860,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 200
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_273_811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_273_811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_273_811",
    x1: 0,
    y1: 0,
    x2: 60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F83600"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscord);
export default __webpack_public_path__ + "static/media/icon-discord.4771be139357d643c0921ddb88363130.svg";
export { ForwardRef as ReactComponent };